module.exports = __webpack_public_path__ + "img/filter copy.8232991a.svg";